export var ERentDepositStatus;
(function (ERentDepositStatus) {
    ERentDepositStatus["New"] = "NEW";
    ERentDepositStatus["OpenToSign"] = "OPEN_TO_SIGN";
    ERentDepositStatus["OpenSigned"] = "OPEN_SIGNED";
    ERentDepositStatus["PayingIn"] = "PAYING_IN";
    ERentDepositStatus["PayingInPartiallySigned"] = "PAYING_IN_PARTIALLY_SIGNED";
    ERentDepositStatus["PaidInPartiallySigned"] = "PAID_IN_PARTIALLY_SIGNED";
    ERentDepositStatus["Established"] = "ESTABLISHED";
    ERentDepositStatus["ReleaseNew"] = "RELEASE_NEW";
    ERentDepositStatus["WaitingForIBAN"] = "WAITING_FOR_IBAN";
    ERentDepositStatus["WaitingForValidations"] = "WAITING_FOR_VALIDATIONS";
    ERentDepositStatus["ReleaseToSign"] = "RELEASE_TO_SIGN";
    ERentDepositStatus["ReleaseSigned"] = "RELEASE_SIGNED";
    ERentDepositStatus["ManualVerification"] = "MANUAL_VERIFICATION";
    ERentDepositStatus["ManualVerificationJudicial"] = "MANUAL_VERIFICATION_JUDICIAL";
    ERentDepositStatus["PayingOut"] = "PAYING_OUT";
    ERentDepositStatus["Released"] = "RELEASED";
    ERentDepositStatus["Cancelled"] = "CANCELLED";
    ERentDepositStatus["WaitingForVerificationByBanqup"] = "WAITING_FOR_VERIFICATION_BY_BANQUP";
    ERentDepositStatus["RequestingBanqupAccount"] = "REQUESTING_BANQUP_ACCOUNT";
    ERentDepositStatus["VerifyingRentDepositHolder"] = "VERIFYING_RENTDEPOSIT_HOLDER";
    ERentDepositStatus["BanqupPendingPayment"] = "BANQUP_PENDING_PAYMENT";
})(ERentDepositStatus || (ERentDepositStatus = {}));
export var EBanqupRequestStatus;
(function (EBanqupRequestStatus) {
    EBanqupRequestStatus["Accepted"] = "ACCEPTED";
    EBanqupRequestStatus["Submitted"] = "SUBMITTED";
    EBanqupRequestStatus["InReview"] = "IN_REVIEW";
    EBanqupRequestStatus["Validated"] = "VALIDATED";
    EBanqupRequestStatus["Rejected"] = "REJECTED";
    EBanqupRequestStatus["Terminated"] = "TERMINATED";
    EBanqupRequestStatus["AutoApproved"] = "AUTO_APPROVED";
})(EBanqupRequestStatus || (EBanqupRequestStatus = {}));
export var EBanqupContractStatus;
(function (EBanqupContractStatus) {
    EBanqupContractStatus["SendToBanqup"] = "SEND_TO_BANQUP";
    EBanqupContractStatus["GeneratingRentDeposit"] = "GENERATING_RENT_DEPOSIT";
    EBanqupContractStatus["RentDepositGenerated"] = "RENT_DEPOSIT_GENERATED";
    EBanqupContractStatus["GeneratingPayments"] = "GENERATING_PAYMENTS";
    EBanqupContractStatus["BanqupMigrating"] = "BANQUP_MIGRATING";
    EBanqupContractStatus["BanqupMigrated"] = "BANQUP_MIGRATED";
    EBanqupContractStatus["BanqupMigratingIbanCreated"] = "BANQUP_MIGRATING_IBAN_CREATED";
    EBanqupContractStatus["SendToBanqupForRelease"] = "SEND_TO_BANQUP_FOR_RELEASE";
    EBanqupContractStatus["BanqupNewAccountVerification"] = "NEW_ACCOUNT_VERIFICATION";
    EBanqupContractStatus["BanqupMigratedAccountVerification"] = "MIGRATED_ACCOUNT_VERIFICATION";
    EBanqupContractStatus["FundsTransferred"] = "FUNDS_TRANSFERRED";
    EBanqupContractStatus["ReleaseFundsTransferred"] = "RELEASE_FUNDS_TRANSFERRED";
    EBanqupContractStatus["Established"] = "ESTABLISHED";
    EBanqupContractStatus["FundsReceived"] = "FUNDS_RECEIVED";
})(EBanqupContractStatus || (EBanqupContractStatus = {}));
export var EAreaOfBusinessActivities;
(function (EAreaOfBusinessActivities) {
    EAreaOfBusinessActivities["Domestic"] = "DOMESTIC";
    EAreaOfBusinessActivities["InternationalEu"] = "INTERNATIONAL_EU";
    EAreaOfBusinessActivities["InternationalBeyondEu"] = "INTERNATIONAL_BEYOND_EU";
    EAreaOfBusinessActivities["NotProvided"] = "NOT_PROVIDED";
})(EAreaOfBusinessActivities || (EAreaOfBusinessActivities = {}));
export var ERentDepositProvider;
(function (ERentDepositProvider) {
    ERentDepositProvider["MangoPay"] = "MANGOPAY";
    ERentDepositProvider["Banqup"] = "BANQUP";
    ERentDepositProvider["Migrated"] = "BANQUP_MIGRATED";
})(ERentDepositProvider || (ERentDepositProvider = {}));
export var EPaymentSource;
(function (EPaymentSource) {
    EPaymentSource["MANGOPAY"] = "Mangopay";
    EPaymentSource["BANQUP"] = "Banqup";
})(EPaymentSource || (EPaymentSource = {}));
